module.exports = __webpack_public_path__ + "static/lifestyle5-19271d7b512e9a360991d3fc663cf18a.jpg";